export type PossibleTypesMap = {
  possibleTypes: {
    AddTrailerChangeResponse: [
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidStopType',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'TractorNotExists',
      'TrailerChangeAdded'
    ]
    AddedCustomerCostCenterResponse: [
      'CostCenterNotExists',
      'CustomerCostCenterUpdated',
      'InvalidCostCenterForCustomer'
    ]
    AddedCustomerLatenessConfigurationResponse: [
      'CustomerLatenessConfigurationNotFound',
      'CustomerLatenessConfigurationUpdated',
      'InvalidCustomerLatenessConfiguration'
    ]
    AssignCarrierToLegResponse: [
      'CarrierAssignedToLeg',
      'InvalidLegIdx',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidSourceSystem',
      'ObjectDoesNotExist'
    ]
    AssignDriversToLegResponse: [
      'DriverAssignedToLeg',
      'InvalidDriverAssignment',
      'InvalidLegStatus',
      'InvalidLegWithCarrierAction',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'TMWValidationError'
    ]
    AssignTractorToLegResponse: [
      'InvalidEquipmentMove',
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidLegWithCarrierAction',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'InvalidTractorStatus',
      'ObjectDoesNotExist',
      'TMWValidationError',
      'TractorAssignedToLeg'
    ]
    AssignTrailerToLoadResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidTrailerAssign',
      'InvalidTrailerStatus',
      'TrailerAssignedToLoad'
    ]
    AssignTrailerToStopResponse: [
      'InvalidLoadStatus',
      'InvalidTrailerAssign',
      'InvalidTrailerStatus',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'TrailerAssignedToStop'
    ]
    CancelLoadResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopStatus',
      'LoadCancelled',
      'ObjectDoesNotExist'
    ]
    CompleteServiceEventResponse: [
      'InvalidServiceEventComplete',
      'InvalidServiceEventStatus',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventCompleted',
      'TrailerServiceEventCompleted'
    ]
    ConsigneeAllowNotificationsUpdateResponse: [
      'ConsigneeAllowNotificationsUpdated',
      'ObjectDoesNotExist'
    ]
    ConsigneeCreateResponse: [
      'ConsigneeAlreadyExists',
      'ConsigneeCreated',
      'InvalidConsigneeCreate',
      'ObjectDoesNotExist'
    ]
    ConsigneeNotificationTypeToggleResponse: [
      'ConsigneeNotificationTypeToggled',
      'ObjectDoesNotExist'
    ]
    CreateCustomerResponse: [
      'CostCenterNotExists',
      'CustomerAlreadyExists',
      'CustomerCreated',
      'InvalidCostCenterCode',
      'InvalidCostCenterForCustomer',
      'InvalidTMCustomerCode'
    ]
    CreateFacilityContactResponse: [
      'FacilityContactCreated',
      'InvalidContact',
      'InvalidEmailAddress',
      'InvalidFacilityForEdit',
      'InvalidPhoneNumber',
      'ObjectDoesNotExist'
    ]
    CreateFacilityNoteResponse: [
      'FacilityNoteCreated',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist'
    ]
    CreateFacilityResponse: [
      'CostCenterNotExists',
      'DuplicateFacilityCode',
      'DuplicateFacilityName',
      'FacilityCreated',
      'InvalidCountryCode',
      'InvalidCountrySubdivisionCode',
      'InvalidFacilityCode',
      'InvalidFacilityName',
      'NotSupportedByCostCenter'
    ]
    CreateLoadNoteResponse: [
      'InvalidLoadNoteCreate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'LoadNoteCreated',
      'ObjectDoesNotExist'
    ]
    CreateNoteResponse: [
      'InvalidNoteBody',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NoteCreated',
      'ObjectDoesNotExist'
    ]
    CreateReferenceResponse: [
      'FreightRecordReferenceCreated',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidReferenceCreate',
      'LoadReferenceCreated',
      'ObjectDoesNotExist',
      'StopReferenceCreated'
    ]
    CreateServiceEventResponse: [
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventCreated',
      'TrailerServiceEventCreated'
    ]
    CreateTrailerResponse: [
      'DuplicateTrailerUnitNumber',
      'DuplicateTrailerVin',
      'InvalidTrailerCreate',
      'ObjectDoesNotExist',
      'TrailerCreated'
    ]
    CustomerExceptionTypes: [
      'AttemptedStopException',
      'DamageException',
      'LateArrivalException',
      'MissingDocumentException',
      'OverageException',
      'RunningLateException',
      'ShortageException',
      'SkippedStopException'
    ]
    CustomerFilterConfigToggleResponse: [
      'CustomerFilterConfigToggled',
      'ObjectDoesNotExist'
    ]
    CustomerUserCreateResponse: [
      'CustomerUserCreated',
      'InvalidEmailAddress',
      'InvalidPassword',
      'InvalidUserCredentials',
      'ObjectDoesNotExist',
      'UserAlreadyExists',
      'UserHasCustomer'
    ]
    CustomerUserUpdateResponse: [
      'CustomerUserUpdated',
      'InvalidCostCenterForCustomer',
      'InvalidCustomerForUser'
    ]
    DeleteFacilityContactResponse: [
      'FacilityContactDeleted',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist'
    ]
    DeleteFacilityNoteResponse: [
      'FacilityNoteDeleted',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist'
    ]
    DeleteNoteResponse: [
      'InvalidLoadNoteDelete',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NoteDeleted',
      'ObjectDoesNotExist'
    ]
    DeleteQualificationResponse: ['ObjectDoesNotExist', 'QualificationDeleted']
    DeleteReferenceResponse: [
      'FreightRecordReferenceDeleted',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'LoadReferenceDeleted',
      'ObjectDoesNotExist',
      'StopReferenceDeleted'
    ]
    DeleteServiceEventResponse: [
      'InvalidServiceEventStatus',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'ServiceEventDeleted'
    ]
    DeleteTrailerChangeResponse: [
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'InvalidTrailerChangeDelete',
      'ObjectDoesNotExist',
      'TrailerChangeDeleted'
    ]
    DispatchLoadToDriverResponse: [
      'DispatchedToDrivers',
      'InvalidDriverAssignment',
      'InvalidLegUpdateError',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoDriverAssignedToLeg',
      'ObjectDoesNotExist',
      'TMWValidationError'
    ]
    DocumentOrMissing: ['Document', 'MissingDocument']
    DocumentResponse: [
      'DocumentList',
      'DocumentListWithMissing',
      'UnableToRetrieveDocuments'
    ]
    DriverShareRequestResponse: ['DriverShareRequest']
    ErrorType: [
      'ConsigneeAlreadyExists',
      'CostCenterNotExists',
      'CustomerAlreadyExists',
      'CustomerLatenessConfigurationNotFound',
      'DefaultTractorAssignmentError',
      'DuplicateFacilityCode',
      'DuplicateFacilityName',
      'DuplicateTrailerUnitNumber',
      'DuplicateTrailerVin',
      'FreightRecordNotExists',
      'GeodapterTimeout',
      'InvalidAttemptStop',
      'InvalidBillToUpdate',
      'InvalidColumnConfiguration',
      'InvalidConsigneeCreate',
      'InvalidContact',
      'InvalidCostCenterCode',
      'InvalidCostCenterForCustomer',
      'InvalidCountryCode',
      'InvalidCountrySubdivisionCode',
      'InvalidCustomerForUser',
      'InvalidCustomerLatenessConfiguration',
      'InvalidDealerNumber',
      'InvalidDriverAssignment',
      'InvalidDriverStatus',
      'InvalidEmailAddress',
      'InvalidEquipmentMove',
      'InvalidExceptionUpdate',
      'InvalidFacilityCode',
      'InvalidFacilityForEdit',
      'InvalidFacilityName',
      'InvalidFreightRecordCreate',
      'InvalidFreightRecordRange',
      'InvalidFreightRecordUpdate',
      'InvalidLegIdx',
      'InvalidLegStartTime',
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidLegWithCarrierAction',
      'InvalidLoadNoteCreate',
      'InvalidLoadNoteDelete',
      'InvalidLoadNoteUpdate',
      'InvalidLoadStatus',
      'InvalidNeedByUpdate',
      'InvalidNoteBody',
      'InvalidOdometer',
      'InvalidOperatingHoursError',
      'InvalidOsdRecord',
      'InvalidPassword',
      'InvalidPhoneNumber',
      'InvalidRadiusVersion',
      'InvalidReferenceCreate',
      'InvalidReferenceUpdate',
      'InvalidRescheduleStop',
      'InvalidRoute',
      'InvalidRouteStopLocation',
      'InvalidRouteUpdate',
      'InvalidServiceEventComplete',
      'InvalidServiceEventStart',
      'InvalidServiceEventStatus',
      'InvalidServiceEventUpdate',
      'InvalidSkipStop',
      'InvalidSourceSystem',
      'InvalidStopAdd',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopDelete',
      'InvalidStopEstimateQuery',
      'InvalidStopEvent',
      'InvalidStopForLeg',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopReorder',
      'InvalidStopStatus',
      'InvalidStopType',
      'InvalidStopUpdateField',
      'InvalidTMCustomerCode',
      'InvalidTMWVersionIDAnton',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'InvalidTenderLoad',
      'InvalidTenderStatus',
      'InvalidTrackingLink',
      'InvalidTractorStatus',
      'InvalidTractorUpdate',
      'InvalidTrailerAssign',
      'InvalidTrailerChangeDelete',
      'InvalidTrailerCreate',
      'InvalidTrailerStatus',
      'InvalidTrailerUpdate',
      'InvalidUndoStops',
      'InvalidUserCredentials',
      'InvalidVinUpdateError',
      'InvalidXMinAway',
      'NoCostCenterAssignedToLoad',
      'NoDriverAssignedToLeg',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'OverlappingPolygons',
      'PermissionTypeError',
      'TMWValidationError',
      'TooManyFavoriteCostCenters',
      'TrackingLinkInternalError',
      'TractorNotExists',
      'UnableToRetrieveDocuments',
      'UserAlreadyExists',
      'UserHasCustomer'
    ]
    ExceptionTypes: [
      'AttemptedStopException',
      'DamageException',
      'LateArrivalException',
      'MissingDocumentException',
      'OverageException',
      'ShortageException',
      'SkippedStopException'
    ]
    ExceptionUpdateResponse: [
      'ExceptionUpdated',
      'InvalidExceptionUpdate',
      'ObjectDoesNotExist'
    ]
    FreightRecordCreateResponse: [
      'FreightRecordCreated',
      'InvalidFreightRecordCreate',
      'InvalidFreightRecordRange',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist'
    ]
    FreightRecordDeleteResponse: [
      'FreightRecordDeleted',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist'
    ]
    FreightRecordUpdateResponse: [
      'FreightRecordUpdated',
      'InvalidFreightRecordRange',
      'InvalidFreightRecordUpdate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist'
    ]
    GetDriversStatusResponse: [
      'DriverWithStatusPaginatedResponse',
      'GeodapterTimeout',
      'InvalidDriverStatus'
    ]
    GetTrackingInfoResponse: [
      'InvalidTrackingLink',
      'TrackingInfo',
      'TrackingLinkInternalError'
    ]
    HarleyDealerUserCreateResponse: [
      'HarleyDealerUserCreated',
      'InvalidDealerNumber',
      'InvalidEmailAddress',
      'InvalidPassword',
      'InvalidUserCredentials',
      'ObjectDoesNotExist',
      'UserAlreadyExists',
      'UserHasCustomer'
    ]
    LayoverStopAddResponse: [
      'InvalidLoadStatus',
      'InvalidOdometer',
      'InvalidRadiusVersion',
      'InvalidStopAdd',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopDateTime',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'LayoverStopAdded',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist'
    ]
    LegPlannedStartTimeResponse: [
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'LegPlannedStartTimeUpdated',
      'ObjectDoesNotExist',
      'TMWValidationError'
    ]
    LoadCreateResponse: [
      'InvalidRouteStopLocation',
      'LoadCreated',
      'ObjectDoesNotExist',
      'TMWValidationError'
    ]
    LoadResponse: ['Load', 'PermissionTypeError']
    LoadSubscription: ['LoadDeleted', 'LoadList']
    LocationConsigneeXMinAwayUpdateResponse: [
      'InvalidXMinAway',
      'LocationConsigneeXMinAwayUpdated',
      'ObjectDoesNotExist'
    ]
    LocationResponse: [
      'InvalidOperatingHoursError',
      'Location',
      'ObjectDoesNotExist',
      'OverlappingPolygons'
    ]
    ManualArriveDepartError: [
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidOdometer',
      'InvalidRadiusVersion',
      'InvalidStopDateTime',
      'InvalidStopForLeg',
      'NoDriverAssignedToLeg',
      'ObjectDoesNotExist'
    ]
    ManualArriveDepartResponse: ['Load', 'ManualArriveDepartInvalid']
    MarkLoadCompletedResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'LoadMarkedCompleted',
      'ObjectDoesNotExist'
    ]
    MergeLegResponse: [
      'InvalidLegIdx',
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'MergeLegSuccess',
      'ObjectDoesNotExist'
    ]
    OsdRecordCreateResponse: [
      'FreightRecordNotExists',
      'InvalidFreightRecordUpdate',
      'InvalidLoadStatus',
      'InvalidOsdRecord',
      'InvalidRadiusVersion',
      'OsdRecordCreated'
    ]
    QualificationResponse: ['ObjectDoesNotExist', 'Qualification']
    RemoveDriverQualificationResponse: [
      'DriverQualificationRemoved',
      'ObjectDoesNotExist'
    ]
    RemovedCustomerCostCenterResponse: ['CustomerCostCenterUpdated']
    RemovedCustomerLatenessConfigurationResponse: [
      'CustomerLatenessConfigurationNotFound',
      'CustomerLatenessConfigurationUpdated',
      'InvalidCustomerLatenessConfiguration'
    ]
    ReorderCompletedStopsError: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopReorder',
      'ObjectDoesNotExist'
    ]
    ReorderCompletedStopsResponse: [
      'CompletedStopsReordered',
      'ReorderCompletedStopsInvalid'
    ]
    SplitLegResponse: [
      'InvalidLegWithCarrierAction',
      'InvalidLoadStatus',
      'InvalidStopEvent',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidTMWVersionIDAnton',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoCostCenterAssignedToLoad',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'SplitLegSuccess',
      'TMWValidationError',
      'TractorNotExists'
    ]
    StartServiceEventResponse: [
      'InvalidServiceEventStart',
      'InvalidServiceEventStatus',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventStarted',
      'TrailerServiceEventStarted'
    ]
    StopAddResponse: [
      'InvalidLegStartTime',
      'InvalidOdometer',
      'InvalidStopAdd',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopEvent',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidStopType',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'StopAdded',
      'TMWValidationError'
    ]
    StopAttemptResponse: [
      'InvalidAttemptStop',
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
      'StopAttempted'
    ]
    StopDeleteResponse: [
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidLoadStatus',
      'InvalidStopDelete',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'StopDeleted',
      'TMWValidationError'
    ]
    StopDuplicateResponse: [
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopEvent',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'StopAdded',
      'TMWValidationError'
    ]
    StopEstimateQueryResponse: [
      'InvalidStopEstimateQuery',
      'ObjectDoesNotExist',
      'StopEstimate'
    ]
    StopReorderResponse: [
      'InvalidLegUpdateError',
      'InvalidLoadStatus',
      'InvalidStopEvent',
      'InvalidStopReorder',
      'InvalidStopStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'StopReordered',
      'TMWValidationError'
    ]
    StopRescheduleResponse: [
      'InvalidLegStatus',
      'InvalidRadiusVersion',
      'InvalidRescheduleStop',
      'InvalidStopEvent',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'StopRescheduled'
    ]
    StopSkipResponse: [
      'InvalidRadiusVersion',
      'InvalidSkipStop',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'ObjectDoesNotExist',
      'StopSkipped'
    ]
    StopUpdateResponse: [
      'InvalidOdometer',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'InvalidStopUpdateField',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'Load',
      'ObjectDoesNotExist',
      'TMWValidationError'
    ]
    StopsUndoneResponse: [
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidUndoStops',
      'ObjectDoesNotExist',
      'StopsUndone'
    ]
    TenderLoadResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidRoute',
      'InvalidTenderLoad',
      'InvalidTenderStatus',
      'LoadTendered',
      'NoCostCenterAssignedToLoad',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist'
    ]
    UpdateBackhaulCodeResponse: [
      'BackhaulCodeUpdated',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'TMWValidationError'
    ]
    UpdateBillToResponse: [
      'BillToUpdated',
      'InvalidBillToUpdate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist'
    ]
    UpdateCustomerResponse: [
      'CustomerUpdated',
      'InvalidTMCustomerCode',
      'ObjectDoesNotExist'
    ]
    UpdateFacilityContactResponse: [
      'FacilityContactUpdated',
      'InvalidContact',
      'InvalidEmailAddress',
      'InvalidFacilityForEdit',
      'InvalidPhoneNumber',
      'ObjectDoesNotExist'
    ]
    UpdateFacilityNoteResponse: [
      'FacilityNoteUpdated',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist'
    ]
    UpdateNoteResponse: [
      'InvalidLoadNoteUpdate',
      'InvalidLoadStatus',
      'InvalidNoteBody',
      'InvalidRadiusVersion',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NoteUpdated',
      'ObjectDoesNotExist'
    ]
    UpdateOsdRecordResponse: [
      'InvalidFreightRecordUpdate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
      'OsdRecordUpdated'
    ]
    UpdateReferenceResponse: [
      'FreightRecordReferenceUpdated',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidReferenceUpdate',
      'LoadReferenceUpdated',
      'ObjectDoesNotExist',
      'StopReferenceUpdated'
    ]
    UpdateRouteResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidRouteUpdate',
      'ObjectDoesNotExist',
      'RouteUpdated'
    ]
    UpdateServiceEventResponse: [
      'InvalidServiceEventStatus',
      'InvalidServiceEventUpdate',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventUpdated',
      'TrailerServiceEventUpdated'
    ]
    UpdateShipmentNeedByResponse: [
      'InvalidNeedByUpdate',
      'ObjectDoesNotExist',
      'ShipmentNeedByUpdated'
    ]
    UpdateTractorSpecificationResponse: [
      'InvalidTractorUpdate',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorSpecificationUpdated'
    ]
    UpdateTrailerCostCenterResponse: [
      'InvalidTrailerUpdate',
      'ObjectDoesNotExist',
      'Trailer'
    ]
    UpdateTrailerSpecificationResponse: [
      'InvalidTrailerUpdate',
      'InvalidVinUpdateError',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TrailerSpecificationUpdated'
    ]
    UpsertCustomerColumnConfigurationResponse: [
      'CustomerColumnConfigurationUpserted',
      'InvalidColumnConfiguration',
      'ObjectDoesNotExist'
    ]
    UserResponse: [
      'InvalidEmailAddress',
      'InvalidPassword',
      'InvalidUserCredentials',
      'ObjectDoesNotExist',
      'User',
      'UserAlreadyExists'
    ]
    UserSettingsResponse: [
      'ObjectDoesNotExist',
      'TooManyFavoriteCostCenters',
      'UserSettings'
    ]
    ValidateTrackingLinkResponse: [
      'InvalidTrackingLink',
      'TrackingLinkInternalError',
      'ValidTrackingLink'
    ]
    WithdrawLoadTenderResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidRoute',
      'InvalidTenderStatus',
      'LoadTenderWithdrawn',
      'NoCostCenterAssignedToLoad',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist'
    ]
  }
}
const result: PossibleTypesMap = {
  possibleTypes: {
    AddTrailerChangeResponse: [
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidStopType',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'TractorNotExists',
      'TrailerChangeAdded',
    ],
    AddedCustomerCostCenterResponse: [
      'CostCenterNotExists',
      'CustomerCostCenterUpdated',
      'InvalidCostCenterForCustomer',
    ],
    AddedCustomerLatenessConfigurationResponse: [
      'CustomerLatenessConfigurationNotFound',
      'CustomerLatenessConfigurationUpdated',
      'InvalidCustomerLatenessConfiguration',
    ],
    AssignCarrierToLegResponse: [
      'CarrierAssignedToLeg',
      'InvalidLegIdx',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidSourceSystem',
      'ObjectDoesNotExist',
    ],
    AssignDriversToLegResponse: [
      'DriverAssignedToLeg',
      'InvalidDriverAssignment',
      'InvalidLegStatus',
      'InvalidLegWithCarrierAction',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'TMWValidationError',
    ],
    AssignTractorToLegResponse: [
      'InvalidEquipmentMove',
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidLegWithCarrierAction',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'InvalidTractorStatus',
      'ObjectDoesNotExist',
      'TMWValidationError',
      'TractorAssignedToLeg',
    ],
    AssignTrailerToLoadResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidTrailerAssign',
      'InvalidTrailerStatus',
      'TrailerAssignedToLoad',
    ],
    AssignTrailerToStopResponse: [
      'InvalidLoadStatus',
      'InvalidTrailerAssign',
      'InvalidTrailerStatus',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'TrailerAssignedToStop',
    ],
    CancelLoadResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopStatus',
      'LoadCancelled',
      'ObjectDoesNotExist',
    ],
    CompleteServiceEventResponse: [
      'InvalidServiceEventComplete',
      'InvalidServiceEventStatus',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventCompleted',
      'TrailerServiceEventCompleted',
    ],
    ConsigneeAllowNotificationsUpdateResponse: [
      'ConsigneeAllowNotificationsUpdated',
      'ObjectDoesNotExist',
    ],
    ConsigneeCreateResponse: [
      'ConsigneeAlreadyExists',
      'ConsigneeCreated',
      'InvalidConsigneeCreate',
      'ObjectDoesNotExist',
    ],
    ConsigneeNotificationTypeToggleResponse: [
      'ConsigneeNotificationTypeToggled',
      'ObjectDoesNotExist',
    ],
    CreateCustomerResponse: [
      'CostCenterNotExists',
      'CustomerAlreadyExists',
      'CustomerCreated',
      'InvalidCostCenterCode',
      'InvalidCostCenterForCustomer',
      'InvalidTMCustomerCode',
    ],
    CreateFacilityContactResponse: [
      'FacilityContactCreated',
      'InvalidContact',
      'InvalidEmailAddress',
      'InvalidFacilityForEdit',
      'InvalidPhoneNumber',
      'ObjectDoesNotExist',
    ],
    CreateFacilityNoteResponse: [
      'FacilityNoteCreated',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist',
    ],
    CreateFacilityResponse: [
      'CostCenterNotExists',
      'DuplicateFacilityCode',
      'DuplicateFacilityName',
      'FacilityCreated',
      'InvalidCountryCode',
      'InvalidCountrySubdivisionCode',
      'InvalidFacilityCode',
      'InvalidFacilityName',
      'NotSupportedByCostCenter',
    ],
    CreateLoadNoteResponse: [
      'InvalidLoadNoteCreate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'LoadNoteCreated',
      'ObjectDoesNotExist',
    ],
    CreateNoteResponse: [
      'InvalidNoteBody',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NoteCreated',
      'ObjectDoesNotExist',
    ],
    CreateReferenceResponse: [
      'FreightRecordReferenceCreated',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidReferenceCreate',
      'LoadReferenceCreated',
      'ObjectDoesNotExist',
      'StopReferenceCreated',
    ],
    CreateServiceEventResponse: [
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventCreated',
      'TrailerServiceEventCreated',
    ],
    CreateTrailerResponse: [
      'DuplicateTrailerUnitNumber',
      'DuplicateTrailerVin',
      'InvalidTrailerCreate',
      'ObjectDoesNotExist',
      'TrailerCreated',
    ],
    CustomerExceptionTypes: [
      'AttemptedStopException',
      'DamageException',
      'LateArrivalException',
      'MissingDocumentException',
      'OverageException',
      'RunningLateException',
      'ShortageException',
      'SkippedStopException',
    ],
    CustomerFilterConfigToggleResponse: [
      'CustomerFilterConfigToggled',
      'ObjectDoesNotExist',
    ],
    CustomerUserCreateResponse: [
      'CustomerUserCreated',
      'InvalidEmailAddress',
      'InvalidPassword',
      'InvalidUserCredentials',
      'ObjectDoesNotExist',
      'UserAlreadyExists',
      'UserHasCustomer',
    ],
    CustomerUserUpdateResponse: [
      'CustomerUserUpdated',
      'InvalidCostCenterForCustomer',
      'InvalidCustomerForUser',
    ],
    DeleteFacilityContactResponse: [
      'FacilityContactDeleted',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist',
    ],
    DeleteFacilityNoteResponse: [
      'FacilityNoteDeleted',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist',
    ],
    DeleteNoteResponse: [
      'InvalidLoadNoteDelete',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NoteDeleted',
      'ObjectDoesNotExist',
    ],
    DeleteQualificationResponse: ['ObjectDoesNotExist', 'QualificationDeleted'],
    DeleteReferenceResponse: [
      'FreightRecordReferenceDeleted',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'LoadReferenceDeleted',
      'ObjectDoesNotExist',
      'StopReferenceDeleted',
    ],
    DeleteServiceEventResponse: [
      'InvalidServiceEventStatus',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'ServiceEventDeleted',
    ],
    DeleteTrailerChangeResponse: [
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'InvalidTrailerChangeDelete',
      'ObjectDoesNotExist',
      'TrailerChangeDeleted',
    ],
    DispatchLoadToDriverResponse: [
      'DispatchedToDrivers',
      'InvalidDriverAssignment',
      'InvalidLegUpdateError',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoDriverAssignedToLeg',
      'ObjectDoesNotExist',
      'TMWValidationError',
    ],
    DocumentOrMissing: ['Document', 'MissingDocument'],
    DocumentResponse: [
      'DocumentList',
      'DocumentListWithMissing',
      'UnableToRetrieveDocuments',
    ],
    DriverShareRequestResponse: ['DriverShareRequest'],
    ErrorType: [
      'ConsigneeAlreadyExists',
      'CostCenterNotExists',
      'CustomerAlreadyExists',
      'CustomerLatenessConfigurationNotFound',
      'DefaultTractorAssignmentError',
      'DuplicateFacilityCode',
      'DuplicateFacilityName',
      'DuplicateTrailerUnitNumber',
      'DuplicateTrailerVin',
      'FreightRecordNotExists',
      'GeodapterTimeout',
      'InvalidAttemptStop',
      'InvalidBillToUpdate',
      'InvalidColumnConfiguration',
      'InvalidConsigneeCreate',
      'InvalidContact',
      'InvalidCostCenterCode',
      'InvalidCostCenterForCustomer',
      'InvalidCountryCode',
      'InvalidCountrySubdivisionCode',
      'InvalidCustomerForUser',
      'InvalidCustomerLatenessConfiguration',
      'InvalidDealerNumber',
      'InvalidDriverAssignment',
      'InvalidDriverStatus',
      'InvalidEmailAddress',
      'InvalidEquipmentMove',
      'InvalidExceptionUpdate',
      'InvalidFacilityCode',
      'InvalidFacilityForEdit',
      'InvalidFacilityName',
      'InvalidFreightRecordCreate',
      'InvalidFreightRecordRange',
      'InvalidFreightRecordUpdate',
      'InvalidLegIdx',
      'InvalidLegStartTime',
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidLegWithCarrierAction',
      'InvalidLoadNoteCreate',
      'InvalidLoadNoteDelete',
      'InvalidLoadNoteUpdate',
      'InvalidLoadStatus',
      'InvalidNeedByUpdate',
      'InvalidNoteBody',
      'InvalidOdometer',
      'InvalidOperatingHoursError',
      'InvalidOsdRecord',
      'InvalidPassword',
      'InvalidPhoneNumber',
      'InvalidRadiusVersion',
      'InvalidReferenceCreate',
      'InvalidReferenceUpdate',
      'InvalidRescheduleStop',
      'InvalidRoute',
      'InvalidRouteStopLocation',
      'InvalidRouteUpdate',
      'InvalidServiceEventComplete',
      'InvalidServiceEventStart',
      'InvalidServiceEventStatus',
      'InvalidServiceEventUpdate',
      'InvalidSkipStop',
      'InvalidSourceSystem',
      'InvalidStopAdd',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopDelete',
      'InvalidStopEstimateQuery',
      'InvalidStopEvent',
      'InvalidStopForLeg',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopReorder',
      'InvalidStopStatus',
      'InvalidStopType',
      'InvalidStopUpdateField',
      'InvalidTMCustomerCode',
      'InvalidTMWVersionIDAnton',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'InvalidTenderLoad',
      'InvalidTenderStatus',
      'InvalidTrackingLink',
      'InvalidTractorStatus',
      'InvalidTractorUpdate',
      'InvalidTrailerAssign',
      'InvalidTrailerChangeDelete',
      'InvalidTrailerCreate',
      'InvalidTrailerStatus',
      'InvalidTrailerUpdate',
      'InvalidUndoStops',
      'InvalidUserCredentials',
      'InvalidVinUpdateError',
      'InvalidXMinAway',
      'NoCostCenterAssignedToLoad',
      'NoDriverAssignedToLeg',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'OverlappingPolygons',
      'PermissionTypeError',
      'TMWValidationError',
      'TooManyFavoriteCostCenters',
      'TrackingLinkInternalError',
      'TractorNotExists',
      'UnableToRetrieveDocuments',
      'UserAlreadyExists',
      'UserHasCustomer',
    ],
    ExceptionTypes: [
      'AttemptedStopException',
      'DamageException',
      'LateArrivalException',
      'MissingDocumentException',
      'OverageException',
      'ShortageException',
      'SkippedStopException',
    ],
    ExceptionUpdateResponse: [
      'ExceptionUpdated',
      'InvalidExceptionUpdate',
      'ObjectDoesNotExist',
    ],
    FreightRecordCreateResponse: [
      'FreightRecordCreated',
      'InvalidFreightRecordCreate',
      'InvalidFreightRecordRange',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
    ],
    FreightRecordDeleteResponse: [
      'FreightRecordDeleted',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
    ],
    FreightRecordUpdateResponse: [
      'FreightRecordUpdated',
      'InvalidFreightRecordRange',
      'InvalidFreightRecordUpdate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
    ],
    GetDriversStatusResponse: [
      'DriverWithStatusPaginatedResponse',
      'GeodapterTimeout',
      'InvalidDriverStatus',
    ],
    GetTrackingInfoResponse: [
      'InvalidTrackingLink',
      'TrackingInfo',
      'TrackingLinkInternalError',
    ],
    HarleyDealerUserCreateResponse: [
      'HarleyDealerUserCreated',
      'InvalidDealerNumber',
      'InvalidEmailAddress',
      'InvalidPassword',
      'InvalidUserCredentials',
      'ObjectDoesNotExist',
      'UserAlreadyExists',
      'UserHasCustomer',
    ],
    LayoverStopAddResponse: [
      'InvalidLoadStatus',
      'InvalidOdometer',
      'InvalidRadiusVersion',
      'InvalidStopAdd',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopDateTime',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'LayoverStopAdded',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
    ],
    LegPlannedStartTimeResponse: [
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'LegPlannedStartTimeUpdated',
      'ObjectDoesNotExist',
      'TMWValidationError',
    ],
    LoadCreateResponse: [
      'InvalidRouteStopLocation',
      'LoadCreated',
      'ObjectDoesNotExist',
      'TMWValidationError',
    ],
    LoadResponse: ['Load', 'PermissionTypeError'],
    LoadSubscription: ['LoadDeleted', 'LoadList'],
    LocationConsigneeXMinAwayUpdateResponse: [
      'InvalidXMinAway',
      'LocationConsigneeXMinAwayUpdated',
      'ObjectDoesNotExist',
    ],
    LocationResponse: [
      'InvalidOperatingHoursError',
      'Location',
      'ObjectDoesNotExist',
      'OverlappingPolygons',
    ],
    ManualArriveDepartError: [
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidOdometer',
      'InvalidRadiusVersion',
      'InvalidStopDateTime',
      'InvalidStopForLeg',
      'NoDriverAssignedToLeg',
      'ObjectDoesNotExist',
    ],
    ManualArriveDepartResponse: ['Load', 'ManualArriveDepartInvalid'],
    MarkLoadCompletedResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'LoadMarkedCompleted',
      'ObjectDoesNotExist',
    ],
    MergeLegResponse: [
      'InvalidLegIdx',
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'MergeLegSuccess',
      'ObjectDoesNotExist',
    ],
    OsdRecordCreateResponse: [
      'FreightRecordNotExists',
      'InvalidFreightRecordUpdate',
      'InvalidLoadStatus',
      'InvalidOsdRecord',
      'InvalidRadiusVersion',
      'OsdRecordCreated',
    ],
    QualificationResponse: ['ObjectDoesNotExist', 'Qualification'],
    RemoveDriverQualificationResponse: [
      'DriverQualificationRemoved',
      'ObjectDoesNotExist',
    ],
    RemovedCustomerCostCenterResponse: ['CustomerCostCenterUpdated'],
    RemovedCustomerLatenessConfigurationResponse: [
      'CustomerLatenessConfigurationNotFound',
      'CustomerLatenessConfigurationUpdated',
      'InvalidCustomerLatenessConfiguration',
    ],
    ReorderCompletedStopsError: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidStopEvent',
      'InvalidStopReorder',
      'ObjectDoesNotExist',
    ],
    ReorderCompletedStopsResponse: [
      'CompletedStopsReordered',
      'ReorderCompletedStopsInvalid',
    ],
    SplitLegResponse: [
      'InvalidLegWithCarrierAction',
      'InvalidLoadStatus',
      'InvalidStopEvent',
      'InvalidStopIdx',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidTMWVersionIDAnton',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoCostCenterAssignedToLoad',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'SplitLegSuccess',
      'TMWValidationError',
      'TractorNotExists',
    ],
    StartServiceEventResponse: [
      'InvalidServiceEventStart',
      'InvalidServiceEventStatus',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventStarted',
      'TrailerServiceEventStarted',
    ],
    StopAddResponse: [
      'InvalidLegStartTime',
      'InvalidOdometer',
      'InvalidStopAdd',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopEvent',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidStopType',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'StopAdded',
      'TMWValidationError',
    ],
    StopAttemptResponse: [
      'InvalidAttemptStop',
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
      'StopAttempted',
    ],
    StopDeleteResponse: [
      'InvalidLegStatus',
      'InvalidLegUpdateError',
      'InvalidLoadStatus',
      'InvalidStopDelete',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'StopDeleted',
      'TMWValidationError',
    ],
    StopDuplicateResponse: [
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopEvent',
      'InvalidStopLocation',
      'InvalidStopStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'StopAdded',
      'TMWValidationError',
    ],
    StopEstimateQueryResponse: [
      'InvalidStopEstimateQuery',
      'ObjectDoesNotExist',
      'StopEstimate',
    ],
    StopReorderResponse: [
      'InvalidLegUpdateError',
      'InvalidLoadStatus',
      'InvalidStopEvent',
      'InvalidStopReorder',
      'InvalidStopStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'StopReordered',
      'TMWValidationError',
    ],
    StopRescheduleResponse: [
      'InvalidLegStatus',
      'InvalidRadiusVersion',
      'InvalidRescheduleStop',
      'InvalidStopEvent',
      'NoCostCenterAssignedToLoad',
      'ObjectDoesNotExist',
      'StopRescheduled',
    ],
    StopSkipResponse: [
      'InvalidRadiusVersion',
      'InvalidSkipStop',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'ObjectDoesNotExist',
      'StopSkipped',
    ],
    StopUpdateResponse: [
      'InvalidOdometer',
      'InvalidStopAppointmentEnd',
      'InvalidStopAppointmentStart',
      'InvalidStopAppointmentTime',
      'InvalidStopDateTime',
      'InvalidStopEvent',
      'InvalidStopStatus',
      'InvalidStopUpdateField',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'Load',
      'ObjectDoesNotExist',
      'TMWValidationError',
    ],
    StopsUndoneResponse: [
      'InvalidLegStatus',
      'InvalidLoadStatus',
      'InvalidUndoStops',
      'ObjectDoesNotExist',
      'StopsUndone',
    ],
    TenderLoadResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidRoute',
      'InvalidTenderLoad',
      'InvalidTenderStatus',
      'LoadTendered',
      'NoCostCenterAssignedToLoad',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
    ],
    UpdateBackhaulCodeResponse: [
      'BackhaulCodeUpdated',
      'InvalidLoadStatus',
      'InvalidTMWVersionIDClient',
      'InvalidTMWVersionIDScos',
      'ObjectDoesNotExist',
      'TMWValidationError',
    ],
    UpdateBillToResponse: [
      'BillToUpdated',
      'InvalidBillToUpdate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
    ],
    UpdateCustomerResponse: [
      'CustomerUpdated',
      'InvalidTMCustomerCode',
      'ObjectDoesNotExist',
    ],
    UpdateFacilityContactResponse: [
      'FacilityContactUpdated',
      'InvalidContact',
      'InvalidEmailAddress',
      'InvalidFacilityForEdit',
      'InvalidPhoneNumber',
      'ObjectDoesNotExist',
    ],
    UpdateFacilityNoteResponse: [
      'FacilityNoteUpdated',
      'InvalidFacilityForEdit',
      'ObjectDoesNotExist',
    ],
    UpdateNoteResponse: [
      'InvalidLoadNoteUpdate',
      'InvalidLoadStatus',
      'InvalidNoteBody',
      'InvalidRadiusVersion',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NoteUpdated',
      'ObjectDoesNotExist',
    ],
    UpdateOsdRecordResponse: [
      'InvalidFreightRecordUpdate',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'ObjectDoesNotExist',
      'OsdRecordUpdated',
    ],
    UpdateReferenceResponse: [
      'FreightRecordReferenceUpdated',
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidReferenceUpdate',
      'LoadReferenceUpdated',
      'ObjectDoesNotExist',
      'StopReferenceUpdated',
    ],
    UpdateRouteResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidRouteUpdate',
      'ObjectDoesNotExist',
      'RouteUpdated',
    ],
    UpdateServiceEventResponse: [
      'InvalidServiceEventStatus',
      'InvalidServiceEventUpdate',
      'InvalidTractorStatus',
      'InvalidTrailerStatus',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorServiceEventUpdated',
      'TrailerServiceEventUpdated',
    ],
    UpdateShipmentNeedByResponse: [
      'InvalidNeedByUpdate',
      'ObjectDoesNotExist',
      'ShipmentNeedByUpdated',
    ],
    UpdateTractorSpecificationResponse: [
      'InvalidTractorUpdate',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TractorSpecificationUpdated',
    ],
    UpdateTrailerCostCenterResponse: [
      'InvalidTrailerUpdate',
      'ObjectDoesNotExist',
      'Trailer',
    ],
    UpdateTrailerSpecificationResponse: [
      'InvalidTrailerUpdate',
      'InvalidVinUpdateError',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
      'TrailerSpecificationUpdated',
    ],
    UpsertCustomerColumnConfigurationResponse: [
      'CustomerColumnConfigurationUpserted',
      'InvalidColumnConfiguration',
      'ObjectDoesNotExist',
    ],
    UserResponse: [
      'InvalidEmailAddress',
      'InvalidPassword',
      'InvalidUserCredentials',
      'ObjectDoesNotExist',
      'User',
      'UserAlreadyExists',
    ],
    UserSettingsResponse: [
      'ObjectDoesNotExist',
      'TooManyFavoriteCostCenters',
      'UserSettings',
    ],
    ValidateTrackingLinkResponse: [
      'InvalidTrackingLink',
      'TrackingLinkInternalError',
      'ValidTrackingLink',
    ],
    WithdrawLoadTenderResponse: [
      'InvalidLoadStatus',
      'InvalidRadiusVersion',
      'InvalidRoute',
      'InvalidTenderStatus',
      'LoadTenderWithdrawn',
      'NoCostCenterAssignedToLoad',
      'NotSupportedByCostCenter',
      'ObjectDoesNotExist',
    ],
  },
}
export default result
